import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from '@shared/services/notifications/notification.service';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private notificationService: NotificationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {

        let errorMessage: string = 'Error desconocido';

        const errorTitle: string = error.error?.message?.title || '';
        const errorDetails: string = error.error?.message?.details || error.message || 'Error desconocido';

        switch (error.status) {
          case 400:
            errorMessage = `Solicitud incorrecta. Detalles: ${errorTitle} - ${errorDetails}`;
            break;
          case 401:
            errorMessage = `No autorizado. Detalles: ${errorTitle} - ${errorDetails}`;
            break;
          case 403:
            errorMessage = `No tiene permisos para realizar esta acción. Detalles: ${errorTitle} - ${errorDetails}`;
            break;
          case 404:
            errorMessage = `El recurso solicitado no fue encontrado. Detalles: ${errorTitle} - ${errorDetails}`;
            break;
          case 409:
            errorMessage = `Conflicto con el estado actual del recurso. Detalles: ${errorTitle} - ${errorDetails}`;
            break;
          case 422:
            errorMessage = `Error de validación. Detalles: ${errorTitle} - ${errorDetails}`;
            break;
          case 500:
            errorMessage = `Error interno del servidor. Detalles: ${errorTitle} - ${errorDetails}`;
            break;
          case 503:
            errorMessage = `Servicio no disponible. Detalles: ${errorTitle} - ${errorDetails}`;
            break;
          default:
            errorMessage = `Error ${error.status}: ${errorTitle} - ${errorDetails}`;
        }
        
        this.notificationService.show('Error', errorMessage,'error');
        
        return throwError(() => error);
      })
    );
  }
}